import React from "react";
import styled from 'styled-components'

const ChevronPath = styled.path`
  fill:white;
` 

const ChevronSvg = styled.svg`
  height:100%;
  width:100%;
`
const  Wrapper = styled.div`
  z-index:15;
  height:30px;
  width:30px;
  border:2px solid white;
  border-radius:50%;
  cursor:pointer;
  >svg{
    margin-left:7px;
    max-width:20px;
  }
`


export const BackButton= (props) => {

function handleClick(){
    window.history.back();
}

  return(
    <>
    <Wrapper {...props} onClick={handleClick}>
      <ChevronSvg  viewBox="0 0 50 50">
        <ChevronPath d="M0.6,24.71L17.32,7.99c0.81-0.81,2.11-0.81,2.92,0l1.95,1.95
      c0.8,0.81,0.8,2.11,0,2.92L8.95,26.17L22.2,39.48c0.8,0.81,0.8,2.11,0,2.92l-1.95,1.95c-0.81,0.81-2.11,0.81-2.92,0L0.6,27.63
      C-0.2,26.82-0.2,25.51,0.6,24.71z"/>
      </ChevronSvg>  
    </Wrapper>  
    </>
  )
}
